import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  fetchWorkspaceInfo,
  getUsers,
} from "slices/userAdmin/actions/userAdmin";
import { setActiveTab, setSearchTerm } from "slices/userAdmin/userAdminSlice";
import UsersWorkspace from "layout/userAdmin/users/UsersWorkspace";
import UsersWorkspaceCreate from "layout/userAdmin/users/UsersWorkspaceCreate";
import UsersHeader from "layout/userAdmin/users/UsersHeader";
import { fetchAuthentication } from "slices/systemAdmin/actions/authentication";
import { addToJobQueue } from "slices/app/appSlice";

const UsersContent = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(addToJobQueue("genericJob"));
    dispatch(setActiveTab(0));
    dispatch(setSearchTerm(""));
    dispatch(fetchAuthentication());
    dispatch(fetchWorkspaceInfo());
    dispatch(getUsers());
  }, [dispatch]);

  return (
    <>
      <UsersHeader />
      <div className="user_admin__header__container">
        <div className="user_admin__container__header">
          <span className="user_admin__header__container__workspace">
            Workspace
          </span>
          <span className="user_admin__container__header__licensed">
            Licensed Users
          </span>
          <span className="user_admin__container__header__non_licensed">
            Non Licensed Users
          </span>
          <span className="user_admin__container__header__reserved_licenses">
            Reserved Licenses
          </span>
        </div>
      </div>
      <div className="user_admin__container" data-testid="users-workspace">
        <UsersWorkspace />
      </div>
      <div className="user_admin__create__workspace__empty__row" />
      <UsersWorkspaceCreate />
    </>
  );
};

export default UsersContent;
